@if (isLoading) {
  <app-loading-spinner
    [text]="'Negotiations'"
  ></app-loading-spinner>
}

@if (contract$ | async; as data) {
  <div class="page-height overflow-auto px-4">
    <div
      class="px-4 pb-5 my-8 mx-auto max-w-6xl flex flex-row justify-between items-center"
      >
      <div class="dark:text-slate-50 text-2xl font-medium">
        Contract Number # {{ data.contract_number }}
      </div>
      <button
        mat-stroked-button
        color="secondary"
        class="my-btn"
        (click)="downloadPDF(data._id)"
        >
        PDF Download
      </button>
    </div>
    <div
      class="flex flex-row justify-center mb-6 items-center gap-2 tablet-min:mx-auto tablet-max:flex-wrap max-w-6xl"
      >
      <mat-card class="my-card rounded-md tablet-max:w-full w-1/2 h-full">
        <mat-card-header class="mb-10">
          <mat-card-title>
            <div class="dark:text-slate-50">Buyer</div>
            <p class="font-medium text-lg my-2">{{ data.buyer_company_name }}</p>
            <p class="text-base">
              {{ data.buyer_address_mail }}, {{ data.buyer_address_mail_city }},
              <br />
              {{ data.buyer_address_mail_province }},
              {{ data.buyer_address_mail_country }}, <br />
              {{ data.buyer_address_mail_postal_code }}
            </p>
            <div></div> </mat-card-title
            ><br />
          </mat-card-header>
          <mat-card-content>
            <div class="grid-container grid grid-cols-2 gap-y-2 break-words">
              <div class="text-xs tablet-min:text-base">Attn:</div>
              <div class="text-sm tablet-min:text-base font-medium">
                {{ data.buyer_first_name }} {{ data.buyer_last_name }}
              </div>
              <div class="text-xs tablet-min:text-base">Email:</div>
              <a
                [href]="'mailto:' + data.buyer_email"
                class="text-sm tablet-min:text-base text-blue-500 font-normal"
                >
                {{ data.buyer_email }}
              </a>
              <div class="text-xs tablet-min:text-base">Cell:</div>
              <a
                [href]="'tel:' + data.buyer_cell_phone"
                class="text-sm tablet-min:text-base text-blue-500 font-normal"
                >{{ data.buyer_cell_phone }}</a
                >
                <div>Work:</div>
                <a
                  [href]="'cell:' + data.buyer_work_number"
                  class="text-sm tablet-min:text-base text-blue-500 font-normal"
                  >{{ data.buyer_work_number || "-" }}
                </a>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="my-card rounded-md tablet-max:w-full w-1/2 h-full">
            <mat-card-header class="mb-10">
              <mat-card-title>
                <div class="dark:text-slate-50">Seller</div>
                <p class="font-medium text-lg my-2">{{ data.seller_company_name }}</p>
                <p class="text-base">
                  {{ data.seller_address_mail }}, {{ data.seller_address_mail_city }},
                  <br />
                  {{ data.seller_address_mail_province }},
                  {{ data.seller_address_mail_country }}, <br />
                  {{ data.seller_address_mail_postal_code }}
                </p></mat-card-title
                ><br />
              </mat-card-header>
              <mat-card-content>
                <div class="grid-container grid grid-cols-2 gap-y-2 break-words">
                  <div class="text-xs tablet-min:text-base">Attn:</div>
                  <div class="text-sm tablet-min:text-base font-medium">
                    {{ data.seller_first_name }} {{ data.seller_last_name }}
                  </div>
                  <div class="text-xs tablet-min:text-base">Email:</div>
                  <a
                    [href]="'mailto:' + data.seller_email"
                    class="text-sm tablet-min:text-base text-blue-500 font-normal"
                    >
                    {{ data.seller_email }}
                  </a>
                  <div class="text-xs tablet-min:text-base">Cell:</div>
                  <a
                    [href]="'tel:' + data.seller_cell_phone"
                    class="text-sm tablet-min:text-base text-blue-500 font-normal"
                    >{{ data.seller_cell_phone }}</a
                    >
                    <div>Work:</div>
                    <a
                      [href]="'cell:' + data.seller_work_number"
                      class="text-sm tablet-min:text-base text-blue-500 font-normal"
                      >{{ data.seller_work_number || "-" }}
                    </a>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <mat-card
              class="my-card rounded-md pt-2 pb-5 my-2 mb-18 tablet-min:mx-auto max-w-6xl"
              >
              <mat-card-header class="mb-4">
                <mat-card-title class="dark:text-gray-300"
                  >Contract Details</mat-card-title
                  >
                </mat-card-header>
                <mat-card-content>
                  <div class="grid grid-cols-2">
                    <div class="mb-4 px-2 grid grid-cols-2 contract-details-grid">
                      <div class="text-sm tablet-min:text-base text-gray-400">
                        Contract Type
                      </div>
                      <div class="text-base tablet-min:text-lg font-medium">
                        @switch(isCashContract()){ @case (true){ Cash } @case(false){ Basis}
                          @default { - } }
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">Origin</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.origin }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Crop Type
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.commodity }}
                          </div>
                          @if (data.product_type) {
                            <div class="text-sm tablet-min:text-base text-gray-400">
                              Product Type
                            </div>
                            <div class="text-base tablet-min:text-lg font-medium">
                              {{ data.product_type }}
                            </div>
                          }
                          <div class="text-sm tablet-min:text-base text-gray-400">Grade</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.grade }}
                          </div>
                          <div class="text-xs tablet-min:text-base text-gray-400">Price</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.currency }} ${{ data.price | priceType }}
                            /
                            {{ data.units }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">Quantity</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.volume_value }} {{ data.units }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Tolerance
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.tolerance || "-" }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Delivery Type
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.delivery_type }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Delivery Option
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.delivery_option }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Container Type
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.container_type }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">Location</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.destination }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">Shipment</div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.ship_begin | date : "MMM d, y" }} -
                            {{ data.ship_end | date : "MMM d, y" }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Rules To Govern
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.rules_to_govern }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Grade/Weight To Govern
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.weight_grade_to_govern }}
                          </div>
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Additional Comments
                          </div>
                          <div class="text-base tablet-min:text-lg font-medium">
                            {{ data.additional_info || "none" }}
                          </div>
                        </div>
                        <div class="grid grid-cols-2 zcontract-details-grid">
                          <div class="text-sm tablet-min:text-base text-gray-400">
                            Specifications
                          </div>
                          <div class="text-base font-medium">
                            @if (!data.specifications.length) {
                              <ng-container class="">
                                -
                              </ng-container>
                            }
                            @for (spec of data.specifications; track spec) {
                              @if (spec.value !== '') {
                                <p class="">
                                  {{ spec.title }} - {{ spec.value }}
                                </p>
                              }
                            }
                          </div>
                          @if(data.documentations && data.documentations.length){
                            <div class="text-sm text-gray-300">Documentations</div>
                            <div
                              class="font-medium text-base czol-span-2 doc-container text-right"
                              >
                              @for (doc of data.documentations; track doc) {
                                @if (doc.value !== null) {
                                  <p class="text-left doc-row">
                                    {{ doc.title }} -
                                    <span class="font-normal text-sm">{{ doc.value }}</span>
                                  </p>
                                }
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <div class="h-16"></div>
                </div>
              }
